// extracted by mini-css-extract-plugin
export var icon = "search-module-module--icon--afa98";
export var iconCollapsed = "search-module-module--iconCollapsed--243cd";
export var iconCollapsedDark = "search-module-module--iconCollapsedDark--15ef3";
export var searchBar = "search-module-module--searchBar--d6c37";
export var searchBarCollapsed = "search-module-module--searchBarCollapsed--fc781";
export var searchBarCollapsedDark = "search-module-module--searchBarCollapsedDark--9a772";
export var searchBarMobile = "search-module-module--searchBarMobile--fad95";
export var searchForm = "search-module-module--searchForm--9d8e7";
export var submitInputButton = "search-module-module--submitInputButton--9892f";
export var submitInputButtonCollapsed = "search-module-module--submitInputButtonCollapsed--bd413";
export var submitInputButtonMobile = "search-module-module--submitInputButtonMobile--d2f8d";